export default "__VITE_PUBLIC_ASSET__007d5cf3__"